/* WhisperGroom page interactions: gallery + reviews carousels and
   smooth-scroll to the reviews section. Uses event delegation so
   bindings survive section re-renders. Add-to-cart is handled by
   Horizon's product-form-component. */
(function () {
  'use strict';

  function trackOf(root) {
    return root ? root.querySelector('[data-wg-track]') : null;
  }

  function stepOf(track) {
    var kids = track.children;
    if (kids.length > 1) {
      var step = kids[1].offsetLeft - kids[0].offsetLeft;
      if (step > 0) return step;
    }
    return track.clientWidth;
  }

  function indexOf(track) {
    return Math.round(track.scrollLeft / stepOf(track));
  }

  /* Last reachable snap position. With several cards per view (desktop
     reviews) this is smaller than childCount - 1. */
  function maxIndexOf(track) {
    var maxScroll = track.scrollWidth - track.clientWidth;
    var step = stepOf(track);
    return step > 0 ? Math.round(maxScroll / step) : 0;
  }

  function goTo(track, i) {
    var max = maxIndexOf(track);
    if (i < 0) i = max;
    if (i > max) i = 0;
    var behavior = document.visibilityState === 'visible' ? 'smooth' : 'auto';
    track.scrollTo({ left: i * stepOf(track), behavior: behavior });
  }

  function syncCarousel(root) {
    var track = trackOf(root);
    if (!track) return;
    var i = indexOf(track);
    var max = maxIndexOf(track);
    var dots = root.querySelectorAll('[data-wg-dot]');
    var thumbs = root.querySelectorAll('[data-wg-thumb]');
    var dotCount = dots.length || 1;
    dots.forEach(function (d, n) {
      /* modulo so the appended loop-clone (index === real count) maps back
         to the first dot instead of leaving none active. */
      d.classList.toggle('is-active', n === i % dotCount);
      d.style.display = n > max ? 'none' : '';
    });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
  }

  function syncAllCarousels() {
    document.querySelectorAll('[data-wg-carousel]').forEach(syncCarousel);
  }

  document.addEventListener('click', function (e) {
    var scrollLink = e.target.closest('[data-wg-scroll]');
    if (scrollLink) {
      var target = document.querySelector(scrollLink.getAttribute('data-wg-scroll'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    var btn = e.target.closest('[data-wg-prev], [data-wg-next], [data-wg-dot], [data-wg-thumb]');
    if (!btn) return;
    var root = btn.closest('[data-wg-carousel]');
    var track = trackOf(root);
    if (!track) return;

    if (btn.hasAttribute('data-wg-prev')) {
      var pi = indexOf(track) - 1;
      /* Loop: stepping back from the first card goes to the last REAL card
         (children.length - 2, since the last child is the appended clone). */
      if (pi < 0 && root.hasAttribute('data-wg-loop')) pi = track.children.length - 2;
      goTo(track, pi);
    } else if (btn.hasAttribute('data-wg-next')) {
      goTo(track, indexOf(track) + 1);
    } else {
      var group = btn.hasAttribute('data-wg-dot') ? '[data-wg-dot]' : '[data-wg-thumb]';
      var items = Array.prototype.slice.call(root.querySelectorAll(group));
      goTo(track, items.indexOf(btn));
    }
  });

  var rafPending = false;
  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.hasAttribute('data-wg-track')) return;
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        syncCarousel(t.closest('[data-wg-carousel]'));
      });
    },
    true
  );

  /* Touch swipe past either edge wraps around: native scroll-snap can't
     overscroll, so a swipe attempt while already at the first/last slide
     is detected here and animated to the opposite end. */
  var swipe = null;
  document.addEventListener(
    'touchstart',
    function (e) {
      var track = e.target.closest('[data-wg-track]');
      if (!track || e.touches.length !== 1) {
        swipe = null;
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      swipe = {
        track: track,
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
        atStart: track.scrollLeft <= 2,
        atEnd: track.scrollLeft >= maxScroll - 2
      };
    },
    { capture: true, passive: true }
  );
  document.addEventListener(
    'touchend',
    function (e) {
      var s = swipe;
      swipe = null;
      if (!s) return;
      var dx = e.changedTouches[0].clientX - s.x;
      var dy = e.changedTouches[0].clientY - s.y;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var sRoot = s.track.closest('[data-wg-carousel]');
      var sLoop = sRoot && sRoot.hasAttribute('data-wg-loop');
      if (dx < 0 && s.atEnd) {
        /* Loop tracks reach the first card by scrolling forward into the
           clone (handled by onSettle), so only non-loop tracks wrap here. */
        if (!sLoop) goTo(s.track, 0);
      } else if (dx > 0 && s.atStart) {
        goTo(s.track, sLoop ? s.track.children.length - 2 : -1);
      }
    },
    { capture: true, passive: true }
  );
  document.addEventListener(
    'touchcancel',
    function () {
      swipe = null;
    },
    { capture: true, passive: true }
  );

  /* Mobile sticky add-to-cart: slides in once the buy-box ATC form has
     been scrolled past (above the viewport), slides away otherwise. */
  function initStickyAtc() {
    var sticky = document.querySelector('[data-wg-sticky]');
    var anchor = document.querySelector('[data-wg-sticky-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      var passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      sticky.classList.toggle('is-visible', passed);
      sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
    });
    observer.observe(anchor);
  }

  /* Dot visibility depends on cards-per-view, so refresh it on load and
     whenever the viewport crosses a breakpoint. */
  window.addEventListener('resize', syncAllCarousels);

  /* Seamless infinite loop for [data-wg-loop] carousels: append a clone of
     the first card; whenever scrolling settles on it, silently snap back to
     the real first card. Auto-advances on mobile, pausing on interaction and
     while off-screen, and never runs under prefers-reduced-motion. */
  function initLoops() {
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-wg-carousel][data-wg-loop]').forEach(function (root) {
      var track = trackOf(root);
      if (!track || track.children.length < 2 || track.querySelector('[data-wg-clone]')) return;

      var clone = track.children[0].cloneNode(true);
      clone.setAttribute('data-wg-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      track.appendChild(clone);
      var realCount = track.children.length - 1;

      function step() { return stepOf(track); }

      function onSettle() {
        var s = step();
        if (s > 0 && Math.round(track.scrollLeft / s) >= realCount) {
          track.scrollTo({ left: track.scrollLeft - realCount * s, behavior: 'auto' });
        }
      }
      if ('onscrollend' in window) {
        track.addEventListener('scrollend', onSettle);
      } else {
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(onSettle, 120);
        }, { passive: true });
      }

      var mq = matchMedia('(max-width: 749px)');
      var timer = null, paused = false, visible = true, resumeT = null;
      function canPlay() { return !reduce && mq.matches && !paused && visible; }
      function advance() {
        if (!canPlay()) return;
        var cur = Math.round(track.scrollLeft / step());
        track.scrollTo({ left: (cur + 1) * step(), behavior: 'smooth' });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (canPlay()) timer = setInterval(advance, 5000); }
      function pause() {
        paused = true;
        stop();
        clearTimeout(resumeT);
        resumeT = setTimeout(function () { paused = false; start(); }, 6000);
      }
      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
        root.addEventListener(ev, pause, { passive: true });
      });
      if (mq.addEventListener) mq.addEventListener('change', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          visible = entries[entries.length - 1].isIntersecting;
          start();
        }, { threshold: 0.3 }).observe(root);
      }
      start();
    });
  }

  /* Lazy-load below-the-fold autoplay videos: cold Meta-ad visitors should
     not pay for the video on the critical path. Load + play only when it
     nears the viewport. */
  function initLazyVideos() {
    var vids = document.querySelectorAll('video[data-wg-lazy-video]');
    if (!vids.length) return;
    function load(v) {
      if (v.dataset.wgLoaded) return;
      v.dataset.wgLoaded = '1';
      if (v.dataset.src) v.src = v.dataset.src;
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) {
      vids.forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { load(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '300px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() {
    initStickyAtc();
    initLoops();
    initLazyVideos();
    syncAllCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
